fragment QuoteMoneyFragment on Money {
    amount
    currency
    formatted
    symbol
    formattedWithCents
}
